import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BOTTOM_NAV_ITEMS } from './navItems';

const BottonNavigation: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <nav
      aria-label="Primary"
      className="lg:hidden sticky bottom-0 z-[999] flex w-full justify-evenly gap-1 bg-brand-900"
      style={{
        paddingBottom: 'env(safe-area-inset-bottom)',
        // Hairline + upward shadow so the bar reads as its own surface
        // rather than a flat slab butted against the content.
        borderTop: '1px solid rgba(250, 249, 248, 0.10)',
        boxShadow: '0 -2px 14px rgba(0, 0, 0, 0.22)',
      }}
    >
      {BOTTOM_NAV_ITEMS.map(({ path, labelKey, Icon }) => {
        const active = pathname === path;
        return (
          <button
            key={path}
            type="button"
            onClick={() => navigate(path)}
            aria-current={active ? 'page' : undefined}
            className={
              'flex-1 min-h-[56px] flex flex-col items-center justify-center gap-1 ' +
              'px-1 pt-2 pb-2 bg-transparent border-0 cursor-pointer ' +
              'transition-colors duration-150 ' +
              (active ? 'text-accent-500' : 'text-brand-300 hover:text-brand-100')
            }
          >
            {/* Pill sits behind the icon only, so the active item reads as
                selected without the label box shifting size. */}
            <span
              className={
                'flex items-center justify-center rounded-full px-4 py-[3px] ' +
                'transition-colors duration-150 ' +
                (active ? 'bg-accent-500/15' : 'bg-transparent')
              }
            >
              <Icon aria-hidden="true" style={{ fontSize: 21 }} />
            </span>
            <span className={'text-[11px] leading-none ' + (active ? 'font-semibold' : 'font-normal')}>
              {t(labelKey)}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottonNavigation;
